module.exports = __WEBPACK_EXTERNAL_MODULE_169__;


/*****************
 ** WEBPACK FOOTER
 ** external "Vue"
 ** module id = 169
 ** module chunks = 0
 **/